import React, { useState, useEffect, forwardRef } from "react";
import { Card, PageTitle } from "../../../styles";
import Table from "../../../components/Table/Table";
import { getActivityData, getPatientMergeLogData, getUsers } from "../../../actions/radminActivityData";
import Box from "../../../components/_styles/Box";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { useFormik } from "formik";
import { EmptyState } from "../../../components/EmptyState/EmptyState";
import { ReactComponent as EmptyStateImg } from "../../../assets/empty-followup.svg";
import { useHistory, useLocation } from "react-router";
import LoadMoreButton from "../../../components/LoadMoreButton";
import Flex from "../../../components/_styles/Flex";
import moment from "moment";
import { capitalize, isArray } from "lodash";
import { ReactComponent as RemoveRecoIcon } from "../../../assets/close-outline.svg";
import DatePicker from "react-datepicker";
import Select, { components } from "react-select";

import { ReactComponent as CalendarIcon } from "../../../assets/calendar-outline.svg";
import { CloseSign, SelectedItemContainer } from "../FollowUpList/FollowUpList";
import close from "../../../assets/cancel-outline-chip.svg";
import { StatusBadge as MessageStatus } from "../Messages/Messages";
import { useRef } from "react";
import { ReactComponent as Search } from "../../../assets/searchIconGrey.svg";
import { Link } from 'react-router-dom';
import { makeStyles, Tooltip } from "@material-ui/core";

const cancelIcon = `${process.env.PUBLIC_URL}/${"cancel-circled.svg"}`;

const useStyles = makeStyles(() => ({
  tooltip: {
    backgroundColor: "#525252",   
    color: "#FFFFFF",             
    fontSize: "12px",
    padding: "6px 10px",
    borderRadius: "4px",
  },
  arrow: {
    color: "#525252", 
  },
}));

const Headercontainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => props.marginBottom};
`;

const DatePickerContainer = styled(Flex)`
  min-width: 227px;
  & > div > div > div {
    height: 38px;
    min-width: 227px;
  }
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const DatePickerButton = styled(Flex)`
  padding: 10px 15px;
  align-items: center;
  background: #ffffff;
  border: 1px solid #d2d3d7;
  border-radius: 4px;
  font-size: 18px;
  width: max-content;
  display: flex;
  justify-content: space-between;
  &:hover {
    cursor: pointer;
  }
`;
const DateContainer = styled(Flex)`
  margin-right: 15px;
  font-size: 14px;
  color: #828282;
  font-family: Open Sans;
`;

const DateClearButton = styled.div`
  cursor: pointer;
  display: flex;
`;

const ToggleContainer = styled(Flex)`
  padding: 1px;
  display: flex;
  background: #e6e9f1;
  border-radius: 8px;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #0c2945;
  width: max-content;
  height: 41px;
`;

const ToggleButton = styled.button`
  padding: 7px 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.active ? "#0C2945" : "#E6E9F1")};
  color: ${(props) => (props.active ? "#F9FAFC" : "#0C2945")};
  border: 0;
  outline: 0;
  border-radius: 6px;
  font-weight: 600;
`;

const StyledLink = styled(Link)`
 color:#00AEEF;
 font-size:14px;
 font-weight:400;
 text-decoration:underline;
`;
const RemoveRecoText = ({ value }) => (
  <td style={{ fontStyle: 'italic', color: 'red' }}>{value ? "Rejected" : "Not Rejected"}</td>
  
);

const columns = [
  { key: "accession_number", name: "Accession Number", align: "left" },
  {
    key: "status_override_from",
    name: "Status Override From",
    displayCell: (status) =>
      status ? (
        <MessageStatus
          styles={{ marginLeft: 0 }}
          status={status}
          dropDown={false}
        />
      ) : (
        "No Status"
      ),
    align: "left",
    paddingLeft:'74px'
  },
  {
    key: "status_override_to",
    name: "Status Override To",
    displayCell: (status) =>
      status ? (
        <MessageStatus
          styles={{ marginLeft: 0 }}
          status={status}
          dropDown={false}
        />
      ) : (
        "No Status"
      ),
    align: "left",
  },
  { key: "user_rejected_status",
    name: "User Rejected Status",
    align: "left",
    displayCell: (value) => 
    value ? (
      <RemoveRecoText value={value} />) : ("Not Rejected")
    //  capitalize(String(value))
  },
  { key: "changed_at", name: "Changed At", align: "left" },
  { key: "user", name: "User", align: "left" }
];
const columnsPatientLog = [
  {
    key: "modified",
    name: "Merged At",
    align: "left",
  },
  {
    key: "merged_by",
    name: "Merged By",
    align: "left",
  },
  {
    key: "merged_in",
    name: "Merged In MRN",
    align: "left",
    displayCell: (value) => (
      <StyledLink
        to={`/auth/radAdmin/followUpList/patients/patientDetails/${value?.id}`}
        onClick={(e) => {
          e.stopPropagation();
          window.analytics.track("Activity-Logs-Patient-Merge-MRN-Click", {
            patientId: value?.id,
          });
        }}
      >
        {value?.mrn}
      </StyledLink>
    ),
  },
];


const SelectDropdownTitle = styled.div`
  margin-bottom: 8px;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #6d6e6e;
  text-transform: uppercase;
`;
const SearchIcon = styled.i`
  display: inline-block;
  position: absolute;
  color: green;
  min-width: 40px;
  left:10px;
`;
const CustomPlaceholder = styled.span`
  position: absolute;
  margin-right: 9px;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0.2px;
  color: #666666;
  @media (max-width: 768px) {
    margin-left: 60px;
  }
`;
const Input = styled.input`
  width: 283px;
  background: white;
  border: 1px solid #d2d3d7;
  border-radius: 5px;
  height: 38px;
  font: normal 16px "Roboto Condensed", sans-serif;
  padding-left: 35px;
`;

const InputContainer = styled.div`
  width: 283px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position:relative;
`;

const ClearButton = styled.button`
  position: absolute;
  border-radius: 5%;
  z-index: 1;
  border: none;
  cursor: pointer;
  color: #000000;
  background-color: transparent;
  transform: translateX(2px);
  right:10px;
`;

const SelectContainer = styled.div`
  width: 227px;
  & div.select__control,
  div.select__value-container {
    height: 38px;
    cursor: pointer;
  }
`;

const Image = styled.img`
  display: block;
  width: 20px;
`;

const SelectedFilters = styled.div`
    display:'flex',
    flex-wrap:'wrap',
    width:'100%',
    justify-content: 'right'
`;

const { ValueContainer } = components;

const CustomValueContainer = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      {props.hasValue ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            left: "10px",
            color: "#828282",
            fontSize: "14px",
            fontWeight: 400,
            fontFamily: "Open Sans",
          }}
        >
          Edit selection...
        </div>
      ) : null}
      {React.Children.map(children, (child) =>
        child && child.props && child.props.className !== "clearIndicator"
          ? child
          : null
      )}
    </ValueContainer>
  );
};

const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: "white", padding:'0px 7px' }),
  option: (styles, { isDisabled, isSelected }) => {
    return {
      ...styles,
      fontSize: "14px",
      color: "black",
      cursor: isDisabled ? "not-allowed" : "default",
      backgroundColor: "white",
      display: "flex",
      width:'100%',
      alignItems:'center'
    };
  },
  multiValue: (styles, { data }) => ({
    ...styles,
    borderRadius: "25px",
    backgroundColor: "#EEEEEE",
    color: "#A1A1A1",
    padding: "4px 10px",
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: "#A1A1A1",
    fontSize: "10px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#828282",
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: "Open Sans",
    marginLeft:'0px'
  }),
  clearIndicator: (provided) => ({
    ...provided,
    display: "none",
  }),
};

const IndicatorsContainer = (props) => {
  return (
    <div style={{ backgroundColor: "#FFF" }}>
      <components.IndicatorsContainer {...props} />
    </div>
  );
};

const MultiValue = (props) => {
  return null;
};

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap:'16px' }}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ margin: "0px", padding: '0px', cursor:'pointer' }}
          />
          <label style={{ margin: 0, padding: '0px', flex: '1', cursor:'pointer' }}>{props.label}</label>
        </div>
      </components.Option>
    </div>
  );
};

const ActivityLogs = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const itemsPortionSize = 10;
  const [displayItemsCount, setDisplayItemsCount] = useState(itemsPortionSize);
  const inputRef = useRef(null);

  const classes = useStyles();

  let initStartDate = null;
  let initEndDate = null;
  let search_accession_number = null;
  let initRange = {
    startDate: null,
    endDate: null,
  };
  let user = [];
  const queryParams = new URLSearchParams(location.search);

  const activeTab = queryParams.get("tab") || "recommendations";

  if (queryParams.has("startDate") && queryParams.has("endDate")) {
    initStartDate = new Date(queryParams.get("startDate"));
    initEndDate = new Date(queryParams.get("endDate"));
    initRange = {
      startDate: queryParams.get("startDate"),
      endDate: queryParams.get("endDate"),
    };
  }
  if (queryParams.has("user")) {
    const userList = queryParams.getAll("user");
    userList.forEach((itm) => {
      user.push({
        value: itm,
        category: "user",
        label: "",
      });
    });
  }
  if (queryParams.has("search_accession_number")) {
    search_accession_number = queryParams.get("search_accession_number");
  }

  const [startDate, setStartDate] = useState(initStartDate);
  const [endDate, setEndDate] = useState(initEndDate);
  const [searchAccession, setSearchAccession] = useState(search_accession_number);
  const [DatesFilter, setDatesFilter] = useState({
    startDate: initRange.startDate,
    endDate: initRange.endDate,
  });
  const [users, setUsers] = useState([]);
  const mounted = useRef();

  const activityLogs = useSelector((state) => state.radAdmin.activityLogs);
  const patientMergeLogs = useSelector((state) => state.radAdmin.patientMergeLogs);

  const [showPlaceholder, setShowPlaceholder] = useState(search_accession_number ? false :true);
  const onHidePlaceholder = () => {
    setShowPlaceholder(false);
  };

  const onShowPlaceholder = () => {
    if (!inputRef.current.value) {
      setShowPlaceholder(true);
    }
  };


  const handleTabChange = (tab) => {
    // Clear all filter & search states
    setSearchAccession('');
    setPageNumber(1);
    setStartDate(null);
    setEndDate(null);
    setDatesFilter({
      startDate: null,
      endDate: null,
    });
    setSelectedValues({
      user: "",
    });
    setShowPlaceholder(true);
  
    formik.resetForm({
      values: {
        searchValue: '',
      },
    });
  
    const params = new URLSearchParams();
    params.set("tab", tab);
    history.replace({ search: params.toString() });

    if(tab === 'recommendations'){

      dispatch(getActivityData(1, { user: "" }, { startDate: null, endDate: null }, ""));
    }else{
      dispatch(getPatientMergeLogData(1, { startDate: null, endDate: null }));
    }

  };

    const formik = useFormik({
        initialValues: {
          searchValue: searchAccession,
        },
        onSubmit: (values) => {
        setPageNumber(1);
        setSearchAccession(values.searchValue);
        return;
        },
      });

  const totalItems = useSelector(
    (state) => state.radAdmin.activityLogs.totalItems
  );
  const totalItemsPatient = useSelector(
    (state) => state.radAdmin.patientMergeLogs.totalItems
  );
  const [selectedValues, setSelectedValues] = useState({
    user: user.length > 0 ? user : "",
  });

  const DatePickerInput = forwardRef(({ onClick, startDate, endDate }, ref) => {
    const formatDate = (date) => {
      return date ? moment(date).format("MMM, DD, YYYY") : "No Date";
    };

    return (
      <DatePickerButton onClick={onClick} ref={ref}>
        <DateContainer>
          {!startDate && !endDate
            ? "Select..."
            : `${formatDate(startDate)} - ${formatDate(endDate)}`}
        </DateContainer>
        {!startDate && !endDate && <CalendarIcon />}
        {(startDate || endDate) && (
          <DateClearButton onClick={resetExamDateFilter}>
            <RemoveRecoIcon />
          </DateClearButton>
        )}
      </DatePickerButton>
    );
  });

  useEffect(() => {
    dispatch(getUsers()).then((res) => {
      if (res) {
        setUsers(
          res?.results?.map((itm) => ({
            label: itm.email,
            value: itm.id,
            category: "user",
          }))
        );
      }
    });
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (endDate) {
      searchParams.set("startDate", DatesFilter.startDate);
      searchParams.set("endDate", DatesFilter.endDate);
    } else {
      searchParams.delete("startDate");
      searchParams.delete("endDate");
    }
  
    if (selectedValues.user) {
      searchParams.delete("user");
        for (let i = 0; i < selectedValues.user.length; i++) {
          searchParams.append("user", selectedValues.user[i].value);
        }
    } else {
      searchParams.delete("user");
    }
    if (searchAccession) {
      searchParams.set("search_accession_number", searchAccession);
    } else {
      searchParams.delete("search_accession_number");
    }
  
    history.push({ search: searchParams.toString() });
    if(activeTab === 'recommendations'){
    dispatch(getActivityData(pageNumber, selectedValues, DatesFilter, searchAccession));
    }else{
      dispatch(getPatientMergeLogData(pageNumber, DatesFilter));

    }
  }, [activeTab,selectedValues.user, endDate, pageNumber, searchAccession]);

  const onResetForm = () => {
    const searchParams = new URLSearchParams(location.search);
    formik.setFieldValue("searchValue", "");
    searchParams.delete("search_accession_number");
    setShowPlaceholder(true);
    setSearchAccession('');
    setPageNumber(1)
    history.push({ search: searchParams.toString() });
  };

  const onLoadMoreLogs = () => {
    if (totalItems >= 10) {
      window.analytics.track("Activity-Logs-Load-More-Click");
      setPageNumber((prevNumber) => prevNumber + 1);
      setDisplayItemsCount(displayItemsCount + itemsPortionSize);
    }
  };
  const onLoadMorepatientLogs = () => {
    if (totalItemsPatient >= 10) {
      window.analytics.track("Activity-Patient-Logs-Load-More-Click");
      setPageNumber((prevNumber) => prevNumber + 1);
      setDisplayItemsCount(displayItemsCount + itemsPortionSize);
    }
  };

  const closeSelected = (category, selectedItem) => {
    setPageNumber(1);
    const filters = selectedValues[category].filter((item) => {
      return item !== selectedItem;
    });
    setSelectedValues({
      ...selectedValues,
      [category]: filters,
    });
  };

  const resetExamDateFilter = () => {
    setPageNumber(1);
    setStartDate(null);
    setEndDate(null);
    setDatesFilter({
      startDate: null,
      endDate: null,
    });
  };

  const onDatesChange = (dates) => {
    if (isArray(dates)) {
      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end);
      setPageNumber(1);
      setDatesFilter({
        startDate: start ? moment(start).format("YYYY-MM-DD") : "",
        endDate: end ? moment(end).format("YYYY-MM-DD") : "",
      });
    }
  };

  return (
    <Box p={30}>
      <style>
      {`
        .MuiTooltip-tooltip {
          background-color: #525252 !important;
          color: white !important;
          font-size: 12px !important;
          padding: 6px 10px !important;
          border-radius: 4px !important;
        }

        .MuiTooltip-arrow {
          color: #525252 !important;
          marginLeft: 20px !important;
        }
      `}
      </style>
      <Headercontainer
        marginBottom={
          Object.values(selectedValues).filter(Boolean).length > 0
            ? "23px"
            : "67px"
        }
      >
        <PageTitle>Activity Logs</PageTitle>
        <div style={{ display: "flex", gap: "20px" }}>
        {activeTab === "recommendations" && (         
           <div>
                      <SelectDropdownTitle>Search</SelectDropdownTitle>
                      <form onSubmit={formik.handleSubmit}>
                       <InputContainer>
                            <SearchIcon>
                              <Search />
                            </SearchIcon>
                            {showPlaceholder && (
                              <>
                                <CustomPlaceholder onClick={
                                  onHidePlaceholder
                                  }>
                                  {"search accession number"}
                                </CustomPlaceholder>
                              </>
                             )}
                            <Input
                              type="text"
                              id={"searchValue"}
                              name={"searchValue"}
                              onFocus={onHidePlaceholder }
                              onBlur= {onShowPlaceholder}
                              onChange={formik.handleChange}
                              value= {formik.values.searchValue}
                              ref={inputRef}
                            />
                            {!showPlaceholder && formik.values.searchValue && (
                              <ClearButton type={"reset"} onClick={
                                onResetForm
                                }>
                                <img src={cancelIcon} />
                              </ClearButton>
                            )} 
                          </InputContainer> 
                          </form>

          </div>)}
          <div>
            <SelectDropdownTitle>Timeframe</SelectDropdownTitle>
            <DatePickerContainer>
              <DatePicker
                selected={startDate}
                onChange={onDatesChange}
                startDate={startDate}
                endDate={endDate}
                customInput={
                  <DatePickerInput startDate={startDate} endDate={endDate} />
                }
                shouldCloseOnSelect={false}
                selectsRange
                dateFormat={"dd/MM/yyyy"}
                popperModifiers={{
                  offset: {
                    enabled: true,
                    offset: "5px, 10px",
                  },
                  preventOverflow: {
                    enabled: true,
                    escapeWithReference: false,
                    boundariesElement: "viewport",
                  },
                }}
              />
            </DatePickerContainer>
          </div>

          {activeTab === "recommendations" && (   <div
            style={{ display: "flex", alignItems: "center", height: "100%" }}
          >
            <SelectContainer>
              <SelectDropdownTitle>User</SelectDropdownTitle>
              <Select
                classNamePrefix="select"
                styles={colourStyles}
                options={users}
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{
                  ValueContainer: CustomValueContainer,
                  Option,
                  IndicatorsContainer,
                  MultiValue,
                }}
                onChange={(value) =>{
                  setPageNumber(1);
                  setSelectedValues({ ...selectedValues, user: value });

                }
                }
                allowSelectAll={true}
                value={selectedValues["user"]}
              />
            </SelectContainer>
          </div>)}
        </div>
      </Headercontainer>
      <SelectedFilters
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          justifyContent: "right",
          alignItems: "center",
          fontSize: "10px",
          gap: "12px",
        }}
      >
        {Object.values(selectedValues).map((item, index) => {
          if (!item) return null;
          return item.map((i) => {
            return (
              <SelectedItemContainer
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "0px",
                  fontWeight:600,
                  color:'#828282'
                }}
                key={i.value + index}
              >
                {i.label
                  ? i.label
                  : users?.find((user) => user.value === i.value)?.label}
                <CloseSign
                  style={{ marginRight: "0px", marginTop:'0px' }}
                  onClick={() => closeSelected(i.category, i)}
                >
                  <Image src={close} alt={"close sign"} />
                </CloseSign>
              </SelectedItemContainer>
            );
          });
        })}
      </SelectedFilters>
        <div>
        <ToggleContainer>
              <ToggleButton
                active={activeTab === "recommendations"}
                onClick={() => handleTabChange("recommendations")}
                >
                Recommendations
              </ToggleButton>
              <ToggleButton
                active={activeTab === "patientMerge"}
                onClick={() => handleTabChange("patientMerge")}
                >
                Patient Merge
              </ToggleButton>
            </ToggleContainer>
        </div>        
        {activeTab === "recommendations" ? (
      <Card
        style={{
          marginTop: "22px",
        }}
      >
        <>
          <Table
            rows={activityLogs.data}
            columns={columns}
            initialPageNumber={activityLogs.pageNumber}
            totalItems={activityLogs.totalItems}
            isLoadingRows={activityLogs.isLoading && pageNumber < 2}
            shouldGetRowActions={false}
            noDataRender={() => (
              <EmptyState
                title={"No Results"}
                img={() => <EmptyStateImg />}
                imageContainerStyles={{ width: "73px", height: "81px" }}
              >
                Sorry, there are no results
              </EmptyState>
            )}
          />
          {activityLogs?.data && activityLogs?.data.length !== 0 && (
            <LoadMoreButton
              title="Load more logs"
              handleClick={onLoadMoreLogs}
              isDisabled={totalItems === activityLogs.data.length}
              isLoading={activityLogs.isLoading}
              style={{
                backgroundColor: "#0c2945",
                fontWeight: 600,
              }}
            />
          )}
        </>
      </Card>
        ) : (
          <Card
        style={{
          marginTop: "22px",
        }}
      >
        <>
          <Table
            rows={patientMergeLogs.data}
            columns={[...columnsPatientLog,
              {
                key: "merged_patients",
                name: "Merged Patients MRN",
                align: "left",
                displayCell: (value) => {
                  if (!value || value.length === 0) return "-";
            
                  return (
                    <div
                      style={{
                        maxHeight: "110px", // ~5 rows worth of space
                        overflowY: value.length > 5 ? "auto" : "visible",
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                        cursor: "pointer",
                        marginTop: "10px",
                      }}
                    >
                      {value.map((patient) => (
                        <Tooltip
                          title="This patient has been merged"
                          placement="top-start"
                          classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                        >
                          <span>{patient.mrn}</span>
                        </Tooltip>
                      ))}
                    </div>
                  );
                },
              },
            ]}
            initialPageNumber={patientMergeLogs.pageNumber}
            totalItems={patientMergeLogs.totalItems}
            isLoadingRows={patientMergeLogs.isLoading && pageNumber < 2}
            shouldGetRowActions={false}
            noDataRender={() => (
              <EmptyState
                title={"No Results"}
                img={() => <EmptyStateImg />}
                imageContainerStyles={{ width: "73px", height: "81px" }}
              >
                Sorry, there are no results
              </EmptyState>
            )}
          />
          {patientMergeLogs?.data && patientMergeLogs?.data.length !== 0 && (
            <LoadMoreButton
              title="Load more logs"
              handleClick={onLoadMorepatientLogs}
              isDisabled={totalItemsPatient === patientMergeLogs.data.length}
              isLoading={patientMergeLogs.isLoading}
              style={{
                backgroundColor: "#0c2945",
                fontWeight: 600,
              }}
            />
          )}
        </>
      </Card>
        )}
    </Box>
  );
};

export default ActivityLogs;
